@for (menuItem of menuItems; track menuItem; let i = $index) {
<ng-container class="dashboard__sidenav-list_item">
  <!-- section -->
  @if ( menuItem.type === 'section' && filter(menuItem.face) && !iconOnlyMode )
  {
  <mat-list-item class="dashboard__section" [disabled]="menuItem.loading">
    @if (!iconOnlyMode) {
    <span class="dashboard__section__title">{{ menuItem.face }}</span>
    }
  </mat-list-item>
  }
  <!-- Icon only mode (start) -->
  @if ( (menuItem.type === 'link' && filter(menuItem.face) && !menuItem.children
  && isVisible(menuItem.key)) || (iconOnlyMode && menuItem.children &&
  filterMatch(i)) ) {
  <mat-list-item
    matRipple
    id="side_menu_list_item_{{
      menuItem.face.toLowerCase().replaceAll(' ', '_')
    }}"
    class="dashboard__sidenav-list_item menu-left-border mat-mdc-list-item-interactive"
    matTooltipPosition="right"
    [routerLink]="
      !iconOnlyMode || !menuItem.children ? menuItem.link : undefined
    "
    [routerLinkActive]="['accent-color', 'accent-border-color']"
    [class.mat-mdc-list-item-reverse]="!iconOnlyMode"
    [class.mat-list-item-content]="iconOnlyMode"
    [class.mat-mdc-list-item-row]="iconOnlyMode"
    [matTooltip]="menuItem.tooltip"
    [routerLinkActiveOptions]="activeMatchOptionsExact"
    [disabled]="menuItem.loading"
    (click)="itemSelect(menuItem)"
  >
    @if (!iconOnlyMode) {
    <div
      matListItemTitle
      class="mat-mdc-list-item-gutters"
      [routerLinkActive]="['accent-color']"
    >
      {{ menuItem.face }}
    </div>
    } @if (menuItem.children && !iconOnlyMode && !menuItem.loading) {
    <mat-icon> keyboard_arrow_right </mat-icon>
    } @if (!menuItem.children) {
    <mat-icon
      matListItemIcon
      id="side_menu_list_item_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      attr.data-testid="side_menu_list_item_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      class="mr-0"
      [routerLinkActive]="['accent-color']"
    >
      @if (!menuItem.loading) {
      <span>{{ menuItem.icon }}</span>
      } @if (menuItem.loading) {
      <mat-spinner [diameter]="27"></mat-spinner>
      }
    </mat-icon>
    } @if (iconOnlyMode && menuItem.children) { @if (!menuItem.loading) {
    <mat-icon
      id="side_menu_list_item_expandable_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      attr.data-testid="side_menu_list_item_expandable_ico_{{
        menuItem.face.toLowerCase().replaceAll(' ', '_')
      }}"
      matListItemIcon
      class="dashboard__sidenav-icon-only-mode"
      #afterMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="afterMenu"
      (click)="afterMenuTrigger.openMenu()"
      >{{ menuItem.icon }}</mat-icon
    >
    } @if (menuItem.loading) {
    <mat-icon matListItemIcon>
      <mat-spinner [diameter]="27"></mat-spinner>
    </mat-icon>
    } }
    <div class="dropdown-content movelist">
      <mat-menu #afterMenu="matMenu" class="side-menu">
        @for (subMenuItem of menuItem.children; track subMenuItem) {
        <div>
          @if (menuItem.type === 'group' && filter(subMenuItem.face)) {
          <mat-list-item
            [disableRipple]="true"
            class="dashboard__sidenav-list_item"
            [disableRipple]="true"
            [ngStyle]="{ 'margin-top': !iconOnlyMode ? '0px' : '40px' }"
            [disabled]="subMenuItem.loading"
          >
            @if (subMenuItem.type !== 'button') {
            <button
              id="side_menu_list_item_ico_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_sub_menu_item_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              attr.data-testid="side_menu_list_item_ico_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_sub_menu_item_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              [disableRipple]="true"
              mat-menu-item
              class="mat-menu-item-contents"
              [routerLinkActive]="['accent-color']"
              [routerLink]="subMenuItem.link"
              [routerLinkActiveOptions]="activeMatchOptions"
            >
              {{ subMenuItem.face }}
              <mat-icon
                matListIcon
                style="padding-right: 10px; padding-left: 25px"
                [routerLinkActive]="['accent-color']"
                [routerLink]="subMenuItem.link"
                [routerLinkActiveOptions]="activeMatchOptions"
                >{{ subMenuItem.icon }}
              </mat-icon>
            </button>
            }
          </mat-list-item>
          } @if ( menuItem.type === 'group' && filter(subMenuItem.face) &&
          subMenuItem.type === 'button' ) {
          <mat-list-item
            [disableRipple]="true"
            class="dashboard__sidenav-list_item"
            [ngStyle]="{ 'margin-top': !iconOnlyMode ? '0px' : '40px' }"
            [disabled]="subMenuItem.loading"
          >
            <div class="button-container">
              <button
                mat-stroked-button
                (click)="itemSelect(subMenuItem)"
                class="button-popup"
              >
                {{ subMenuItem.face }}
              </button>
            </div>
          </mat-list-item>
          }
        </div>
        }
      </mat-menu>
    </div>
  </mat-list-item>
  }
  <!-- Icon only mode (end) -->
  <!-- ----------------------------- List Items with children ----------------------------------- -->
  @if ( menuItem.children && !iconOnlyMode && (filter(menuItem.face) ||
  bulkFilter(menuItem)) && filterMatch(i) ) {
  <mat-accordion
    id="side_menu_list_item_expandable_{{
      menuItem.face.toLowerCase().replaceAll(' ', '_')
    }}"
    attr.data-testid="side_menu_list_item_expandable_{{
      menuItem.face.toLowerCase().replaceAll(' ', '_')
    }}"
    displayMode="flat"
    class="child-headers-align"
    multi
  >
    <mat-expansion-panel
      style="padding: 0px; border: none"
      class="rounded-0"
      [expanded]="menuItem.key !== 'REFERENCES' ? menuItem.expanded : false"
      (expandedChange)="menuItem.expanded = $event"
      (opened)="beforeExpand(menuItem)"
    >
      <mat-expansion-panel-header
        matRipple
        class="menu-left-border rounded-0 dashboard__sidenav-list_item"
        [collapsedHeight]="'48px'"
        [expandedHeight]="'48px'"
        [routerLinkActive]="['accent-color', 'accent-border-color']"
        [routerLinkActiveOptions]="{ exact: false }"
        #parentMenu="routerLinkActive"
      >
        <mat-panel-title style="font-size: 12.8px">
          {{ menuItem.face }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (subMenuItem of menuItem.children; track subMenuItem) {
      <ng-container class="dashboard__sidenav-list_item">
        <div>
          @if ( subMenuItem.type === 'section' && filter(subMenuItem.face) &&
          !iconOnlyMode ) {
          <mat-list-item
            style="
              height: 25px;
              background-color: rgba(0, 0, 0, 0.1);
              pointer-events: none;
              padding-left: 0px;
            "
            [disabled]="subMenuItem.loading"
          >
            @if (!iconOnlyMode) {
            <span style="padding-left: 8px; font-size: 10px" matLine>{{
              subMenuItem.face
            }}</span>
            }
          </mat-list-item>
          } @if ( (subMenuItem.type === 'link' && filter(subMenuItem.face) &&
          !subMenuItem.children && isVisible(subMenuItem.key)) || (iconOnlyMode
          && subMenuItem.children) ) {
          <mat-list-item
            matRipple
            id="side_menu_list_item_{{
              menuItem.face.toLowerCase().replaceAll(' ', '_')
            }}_sub_menu_item_{{
              subMenuItem.face.toLowerCase().replaceAll(' ', '_')
            }}"
            attr.data-testid="side_menu_list_item_{{
              menuItem.face.toLowerCase().replaceAll(' ', '_')
            }}_sub_menu_item_{{
              subMenuItem.face.toLowerCase().replaceAll(' ', '_')
            }}"
            [disableRipple]="true"
            class="dashboard__sidenav-list_item menu-left-border child-element mat-mdc-list-item-interactive"
            [routerLink]="subMenuItem.link"
            [routerLinkActiveOptions]="activeMatchOptions"
            [class.mat-mdc-list-item-content]="iconOnlyMode"
            [class.mat-mdc-list-item-reverse]="!iconOnlyMode"
            [disabled]="subMenuItem.loading"
            (click)="itemSelect(subMenuItem)"
          >
            <!-- <h4 style="padding-left: 5px" *ngIf="!iconOnlyMode" matLine>
                        {{ subMenuItem.face }}
                      </h4> -->
            @if (!iconOnlyMode) {
            <div
              matListItemTitle
              class="mat-mdc-list-item-gutters"
              [routerLinkActive]="['accent-color']"
            >
              {{ subMenuItem.face }}
            </div>
            } @if ( subMenuItem.children && !iconOnlyMode &&
            !subMenuItem.loading ) {
            <mat-icon> keyboard_arrow_right </mat-icon>
            }
            <!-- ----------------------------- List Items without children for Icon only mode ----------------------------------- -->
            <!-- <button
              id="side_menu_list_item_ico_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_submenu_item_no_children_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              attr.data-testid="side_menu_list_item_ico_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_submenu_item_no_children_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
                      [disableRipple]="true"
                      mat-button
                      class="m-0 p-0"
                      *ngIf="!subMenuItem.children"
                      >
                      <mat-icon
                        [ngStyle]="{ 'padding-left': iconOnlyMode ? '0px' : '8px' }"
                        >
                        <span *ngIf="!subMenuItem.loading">{{ subMenuItem.icon }}</span>
                        <mat-spinner
                          *ngIf="subMenuItem.loading"
                          [diameter]="27"
                        ></mat-spinner>
                      </mat-icon>
                    </button> -->
            @if (!subMenuItem.children) {
            <mat-icon
              matListItemIcon
              id="side_menu_list_subitem_ico_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              attr.data-testid="side_menu_list_subitem_ico_{{
                subMenuItem.face.toLowerCase().replaceAll(' ', '_')
              }}"
              class="mr-0"
              [routerLinkActive]="['accent-color']"
            >
              @if (!subMenuItem.loading) {
              <span>{{ subMenuItem.icon }}</span>
              } @if (subMenuItem.loading) {
              <mat-spinner [diameter]="27"></mat-spinner>
              }
            </mat-icon>
            }
          </mat-list-item>
          } @if (subMenuItem.type === 'button') {
          <div class="button-container" style="margin-bottom: 10px">
            <button
              id="side_menu_list_item_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_submenu_item_btn{{
                subMenuItem.face
                  .toLowerCase()
                  .replace('+', '')
                  .replaceAll(' ', '_')
              }}"
              attr.data-testid="side_menu_list_item_{{
                menuItem.face.toLowerCase().replaceAll(' ', '_')
              }}_submenu_item_btn{{
                subMenuItem.face
                  .toLowerCase()
                  .replace('+', '')
                  .replaceAll(' ', '_')
              }}"
              mat-stroked-button
              (click)="itemSelect(subMenuItem)"
            >
              {{ subMenuItem.face }}
            </button>
          </div>
          }
        </div>
      </ng-container>
      }
    </mat-expansion-panel>
  </mat-accordion>
  }
  <!-- ----------------------------- List Items with children ----------------------------------- -->
</ng-container>
}
